var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sub-menu',{attrs:{"title":_vm.title,"routes":_vm.routes}}),_c('router-view',{staticClass:"mt-6"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }